import RecordsService from '../services/records.service';
import store from '../store/index';
import { computed } from 'vue';

class RecordsUtils {
  async searchRecords() {
    const fileId = computed({
      get: () => store.state.fileRecords.fileId,
    });
    const dateFrom = computed({
      get: () => store.state.fileRecords.daysRange.from == "" ? null : store.state.fileRecords.daysRange.from,
    });

    const dateTo = computed({
      get: () => store.state.fileRecords.daysRange.to == "" ? null : store.state.fileRecords.daysRange.to,
    });
    const organisations = computed({
      get: () => store.state.fomoStatisticsSearch.organisationsSelectArray,
    });

    const subjects = computed({
      get: () => store.state.fomoStatisticsSearch.subjectsSelectArray,
    });

    const customers = computed({
      get: () => store.state.fomoStatisticsSearch.customersSelectArray,
    });
    const scopes = computed({
      get: () => store.state.fomoStatisticsSearch.selectedScopes,
    });
    console.log('xxx', store.state.fomoStatisticsSearch);
    await RecordsService.filterRecords(
      fileId.value,
      dateFrom.value,
      dateTo.value,
      organisations.value,
      subjects.value,
      customers.value,
      scopes.value
    );
  }
}

export default new RecordsUtils();
